import LegacySettings from "../legacySettings/Settings";
import { releaseFeatures } from "@/config/releaseFeatures";
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Page from "@/components/layout/account-page";

import GamePlay from "./GamePlay";
import GameFilter from "./GameFilter";
import Email from "./Email";
import Password from "./Password";
import CloseAccount from "./CloseAccount";
import ChessSet from "./ChessSet";
import EmailPreferences from "./EmailPreferences";

import styles from "./styles/Settings.module.css";
import { FaCog } from "react-icons/fa";
// import { FaTrophy } from 'react-icons/fa';
// import { useRouter } from "next/router";
import Head from "next/head";
import Link from "next/link";

function Settings({ page }) {
  const { t } = useTranslation("common");
  const { t: settingsT } = useTranslation("auth");

  // const router = useRouter();
  // const { page } = router.query;

  // console.log("router.query", router.query);

  const activePage = Number(page);

  function renderPage() {
    switch (activePage) {
      case 0:
        return <ChessSet />;
      case 1:
        return <GamePlay />;
      case 2:
        return <GameFilter />;
      case 3:
        return <Email />;
      case 4:
        return <Password />;
      case 5:
        return <CloseAccount />;
      case 6:
        return <EmailPreferences />;
      default:
        return <GamePlay />;
    }
  }

  const itemStyles = [
    styles.sidebarItem,
    styles.sidebarItem,
    styles.sidebarItem,
    styles.sidebarItem,
    styles.sidebarItem,
    styles.sidebarItem,
    styles.sidebarItem,
  ].map((item, i) => (i === activePage ? item + " " + styles.active : item));

  const pageTitle = (
    <h1 className="flex items-center gap-2 text-2xl font-semibold leading-tight md:text-3xl">
      <span className="text-[0.85em] text-orange-400">
        <FaCog />
      </span>
      <span>{t("Settings")}</span>
    </h1>
  );

  return (
    <Page title={pageTitle}>
      <Head>
        <title>{"Chess Hotel | " + t("Settings")}</title>
        <meta name="description" content={t("description")} />
        <meta name="keywords" content={t("keywords")} />
      </Head>
      <div className={styles.wrapper}>
        <nav className={styles.sidebar} aria-label={t("Settings")}>
          <Link
            aria-current={activePage === 0 ? "page" : undefined}
            className={itemStyles[0]}
            href="/settings/0"
          >
            {settingsT("Chess sets")}
          </Link>
          <Link
            aria-current={activePage === 1 ? "page" : undefined}
            className={itemStyles[1]}
            href="/settings/1"
          >
            {settingsT("Game behavior")}
          </Link>
          <Link
            aria-current={activePage === 2 ? "page" : undefined}
            className={itemStyles[2]}
            href="/settings/2"
          >
            {settingsT("Game filter")}
          </Link>
          <Link
            aria-current={activePage === 3 ? "page" : undefined}
            className={itemStyles[3]}
            href="/settings/3"
          >
            {settingsT("Update email")}
          </Link>
          <Link
            aria-current={activePage === 4 ? "page" : undefined}
            className={itemStyles[4]}
            href="/settings/4"
          >
            {settingsT("Update password")}
          </Link>
          <Link
            aria-current={activePage === 6 ? "page" : undefined}
            className={itemStyles[6]}
            href="/settings/6"
          >
            {settingsT("Email settings")}
          </Link>
          <Link
            aria-current={activePage === 5 ? "page" : undefined}
            className={itemStyles[5]}
            href="/settings/5"
          >
            {settingsT("Close account")}
          </Link>
        </nav>
        {renderPage()}
      </div>
    </Page>
  );
}

export default releaseFeatures.accountRedesign ? Settings : LegacySettings;
